import styled from 'styled-components'

import TrustpilotReviews from 'components/_special/TrustpilotReviews'

export const TrustpilotReviewsStyled = styled(TrustpilotReviews)`
  ${p => p.theme.mq.upMd} {
    padding-bottom: 0 !important;
  }
`
